/* eslint-disable no-restricted-properties */
import { accountTypeAccessPortal } from 'shared/constants';

export const getRedirectPath = () => {
  const user = localStorage.user ? JSON.parse(localStorage.user) : null;
  const accountTypes = user?.accountTypes || [];

  if (accountTypes.length === 0) {
    return '/';
  }

  if (accountTypes.length === 1) {
    return `/${accountTypeAccessPortal[accountTypes]}`;
  }

  return '/auth/portals';
};
